/*-----------------------------------------------------------------
- Division Vuex
-----------------------------------------------------------------*/

const state = {
    division: {},
};

const getters = {
    division: (s) => s.division,
};

const mutations = {
    /**
     * Set division
     * 
     * @param {*} st
     * @param {*} division
     */
    division(st, division) {
        // eslint-disable-next-line no-param-reassign
        st.division = division;
    },
};

const actions = {
    /**
     * Set division
     *
     * @param {*} commit
     * @param {*} commit.commit
     * @param {*} division
     */
    setDivision({ commit }, division) {
        commit('division', division);
    },
};

export default {
    namespaced: true,

    state,
    getters,
    mutations,
    actions,
};
